import React from 'react';
import './OutOfKarmaModal.css';

function OutOfKarmaModal({ isOpen, onClose }) {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content out-of-karma" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={onClose} aria-label="Close">
                    ×
                </button>
                <div className="modal-icon">⏳</div>
                <h2 className="modal-title">Out of Karma!</h2>
                <p className="modal-message">
                    You've used all your karma for today. Return tomorrow for more!
                </p>
                <div className="modal-actions">
                    <button className="btn-close-modal" onClick={onClose}>
                        Got it
                    </button>
                </div>
            </div>
        </div>
    );
}

export default OutOfKarmaModal;
